export default {
    getAllAcademicEvents({ state, commit, rootState })
    {
        commit('getAllAcademicEvents')
    },
    getNewAcademicEvents({ state, commit, rootState }, data)
    {
        commit('getNewAcademicEvents', data)
    },
    getNewEvents({ state, commit, rootState }, data)
    {
        commit('getNewEvents', data)
    },
    getAllEvents({ state, commit, rootState })
    {
        commit('getAllEvents')
    },
    getArticles({ state, commit, rootState })
    {
        commit('getArticles')
    },
    getSportArticles({ state, commit, rootState })
    {
        commit('getSportArticles')
    },
    getArticle({ state, commit, rootState }, data)
    {
        commit('getArticle', data)
    },
    getUpcomingEvents({ state, commit, rootState })
    {
        commit('getUpcomingEvents')
    },
    getUpcomingEvent({ state, commit, rootState }, data)
    {
        commit('getUpcomingEvent', data)
    }
}